import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=2360791c&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=2360791c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360791c",
  null
  
)

export default component.exports